import { render, staticRenderFns } from "./PunishRecord.vue?vue&type=template&id=32f92808&scoped=true&"
import script from "./PunishRecord.vue?vue&type=script&lang=js&"
export * from "./PunishRecord.vue?vue&type=script&lang=js&"
import style0 from "./PunishRecord.vue?vue&type=style&index=0&id=32f92808&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f92808",
  null
  
)

export default component.exports